import { render } from "./HtmlAnnotation.vue?vue&type=template&id=7e97fcaf"
import script from "./HtmlAnnotation.vue?vue&type=script&lang=js"
export * from "./HtmlAnnotation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__